import { createFileRoute } from "@tanstack/react-router";
import { CategoryPage } from "@/components/CategoryPage";
import { getAllPosts } from "@/lib/posts.functions";
import { useLocalizedPosts } from "@/lib/wp.hooks";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/sustainability-critique")({
  head: () => ({
    meta: [
      { title: pageTitle("Sustainability Critique", "en") },
      { name: "description", content: "Critical essays on greenwashing, ESG and the limits of mainstream sustainability discourse." },
      { property: "og:title", content: "Sustainability Critique — Smart Sustainability" },
      { property: "og:description", content: "Critical essays on the limits of sustainability discourse." },
      { property: "og:url", content: "https://smartsustainability.ai/sustainability-critique" },
      { property: "og:locale", content: "en_US" },
      { property: "og:locale:alternate", content: "tr_TR" },
    ],
    links: [
      { rel: "canonical", href: "https://smartsustainability.ai/sustainability-critique" },
      ...hreflangLinks("/surdurulebilirlik", "/sustainability-critique"),
    ],
  }),
  loader: () => getAllPosts(),
  component: SustainabilityPage,
});

function SustainabilityPage() {
  const { t } = useT();
  const { articles: posts } = useLocalizedPosts(Route.useLoaderData());
  return (
    <CategoryPage
      category={t("cat.sustain.title")}
      tagline={t("cat.sustain.tagline")}
      essays={posts.filter((p) => String(p.category) === "Sustainability Critique" || String(p.category) === "Sürdürülebilirlik Eleştirisi" || String(p.category) === "Sürdürülebilirlik")}
    />
  );
}
